import defprotocol from '../defprotocol'
import Function from '../types/Function'

const Reducable = defprotocol({
  reduce: Function
})

export default Reducable
